import { useTranslation } from 'react-i18next'
import { FormikContextType, useFormikContext } from 'formik'
import { Stack, Columns, Column, Checkbox } from '@machobear/design-system'
import { FieldInput } from '@/components/ds-form'

import { FormSection } from '../../components'
import { DetailsFormValues } from '../../types'

const PropertyRulesFields = () => {
  const { t } = useTranslation()
  const { values, setFieldValue }: FormikContextType<DetailsFormValues> =
    useFormikContext<DetailsFormValues>()

  return (
    <FormSection label={t('Property rules', 'Property rules')}>
      <Stack space="gutter" align="left">
        <Checkbox
          id="allow_smoking"
          name="allow_smoking"
          checked={values.allow_smoking}
          label={t('Smoking allowed', 'Smoking allowed')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const isChecked = e?.target?.checked
            setFieldValue('allow_smoking', isChecked)
          }}
        />
        <Checkbox
          id="allow_pets"
          name="allow_pets"
          checked={values.allow_pets}
          label={t('Pets allowed', 'Pets allowed')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const isChecked = e?.target?.checked
            setFieldValue('allow_pets', isChecked)
          }}
        />
      </Stack>
      {!!values.allow_pets && (
        <Columns space="gutter" collapseBelow="tablet">
          <Column width="1/2">
            <FieldInput
              name="allow_cats"
              label={t('Number of cats allowed', 'Number of cats allowed')}
              type="number"
            />
          </Column>
          <Column width="1/2">
            <FieldInput
              name="allow_dogs"
              label={t('Number of dogs allowed', 'Number of dogs allowed')}
              type="number"
            />
          </Column>
        </Columns>
      )}
    </FormSection>
  )
}

export default PropertyRulesFields
